import {toast} from 'react-toastify'
import {getItemFromStorage} from 'utils/storage'

// Investor accounts are view-only: they can browse everything a member and
// a business owner can, and the API refuses their writes (403 VIEW_ONLY)
// apart from likes, saves, Sharpet chat and messaging the SHARPENN team.
// Controls stay visible; using one shows a single "view-only" notice.

export const VIEW_ONLY_MESSAGE = 'Investor accounts are view-only'

const TOAST_ID = 'view-only'
// A refused write usually also lands in the caller's own onError, which
// would toast a generic failure right after this notice. notifyErrorOccured
// stays quiet for this long after a view-only notice.
const QUIET_MS = 2000
let lastNoticeAt = 0

export const isViewOnlyUser = () =>
  Boolean(
    getItemFromStorage({name: 'profile'})?.isInvestor ||
    getItemFromStorage({name: 'user'})?.isInvestor
  )

export const notifyViewOnly = () => {
  lastNoticeAt = Date.now()
  // A fixed toastId: repeated attempts while the notice is up don't stack.
  if (toast.isActive(TOAST_ID)) return
  toast.warning(VIEW_ONLY_MESSAGE, {
    toastId: TOAST_ID,
    position: 'top-center',
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    theme: 'light',
    className: 'custom-toast',
  })
}

export const viewOnlyNoticeIsRecent = () => Date.now() - lastNoticeAt < QUIET_MS

export const isViewOnlyError = (error) =>
  error?.isViewOnly === true ||
  (error?.response?.status === 403 &&
    error?.response?.data?.code === 'VIEW_ONLY')

/**
 * Guard for a submit or upload: true when the member may go ahead.
 * Investors get the view-only notice instead, before any upload starts.
 */
export const requireWritable = () => {
  if (!isViewOnlyUser()) return true
  notifyViewOnly()
  return false
}
